import { useState, useEffect } from 'react';
import { AnnouncementListPagination } from 'types/Announcement';

export const usePagination = (pagination: AnnouncementListPagination) => {
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [pageSize, setPageSize] = useState(12);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        if (pagination) {
            setPage(pagination.current ?? 0);
            setTotalCount(pagination.total ?? 0);
            setPageSize(pagination.pageSize ?? 12);
            setTotalPages(
                Math.ceil((pagination.total ?? 0) / (pagination.pageSize ?? 12))
            );
        }
    }, [pagination]);

    const goToPage = (newPage: number) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    return {
        page,
        setPage,
        totalCount,
        setTotalCount,
        pageSize,
        setPageSize,
        goToPage,
    };
};
